import { InjectionToken, NgModule, APP_INITIALIZER, ModuleWithProviders } from '@angular/core';
// import {
//     MSAL_CONFIG,
//     MSAL_CONFIG_ANGULAR,
//     MsalAngularConfiguration
//     , MsalService, MsalModule, MsalInterceptor
// } from '@azure/msal-angular';
// import { Configuration, Logger, LogLevel } from 'msal';
import { CommonModule } from '@angular/common';
import { MsalModule, MsalService, MsalGuard, MsalInterceptor, MsalBroadcastService, MsalRedirectComponent, MSAL_INSTANCE, MsalInterceptorConfiguration, MSAL_INTERCEPTOR_CONFIG } from "@azure/msal-angular";
import { PublicClientApplication, InteractionType, BrowserCacheLocation, IPublicClientApplication, LogLevel } from "@azure/msal-browser";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConfigService } from '../services/app-config.service';
import { RebarInterceptor } from '../services/RebarInterceptor';


const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');

export function initializerFactory(env: AppConfigService): any {
    // APP_INITIALIZER, except a function return which will return a promise
    // APP_INITIALIZER, angular doesnt starts application untill it completes
    const promise = env.load().then((value) => {
        console.log("Entered initializerFactory in MSAL app module. env=",env);
    });
    return () => promise;
}

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;


export function MSALInstanceFactory(config: AppConfigService): IPublicClientApplication {
    console.log("Exceuted MSAL config factory",config)
    return new PublicClientApplication({
      auth: {
        clientId: config.getSettings('mslConfig.clientID'),
        authority: config.getSettings('mslConfig.authority'),
        redirectUri: config.getSettings('mslConfig.redirectUri'),
        postLogoutRedirectUri: config.getSettings('mslConfig.logoutUri')
        // navigateToLoginRequestUrl: false
      //  clientId: "a0bcd807-5534-4a44-aa4e-04498af88c8e",
      //  redirectUri: "http://localhost:4200"
        // clientId: config.mslConfig.clientID,
        // redirectUri: config.getSettings('mslConfig.redirectUri'),
        // authority: config.getSettings('mslConfig.authority'),
       // scope: "client_credentials"
      },
      cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,              
        // cacheLocation: config.getSettings('mslConfig.cacheLocation'),
        storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Error,
          piiLoggingEnabled: false
        }
      }
      
    });

  }
  export function loggerCallback(logLevel: LogLevel, message: string) {
    console.log(logLevel+" "+message);
    }
// export function msalConfigFactory(config: AppConfigService): Configuration {
//     let protectedResourceMap: Map<string, string[]> = new Map<string, string[]>();
//     let configMSAL: Configuration = {
//         auth: {
//             clientId: config.getSettings('mslConfig.clientID'),
//             authority: config.getSettings('mslConfig.authority'),
//             validateAuthority: true,
//             redirectUri: config.getSettings('mslConfig.redirectUri'),
//             postLogoutRedirectUri: config.getSettings('mslConfig.logoutUri'),
//             navigateToLoginRequestUrl: false,
//         },
//         cache: {
//             cacheLocation: config.getSettings('mslConfig.cacheLocation'),
//             storeAuthStateInCookie: isIE,           
//         },       
//     };
//     return configMSAL;
// }

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  
    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap
    };
  }
  

// export function msalAngularConfigFactory(config: AppConfigService): MsalAngularConfiguration {
//     let protectedResourceMap: Map<string, string[]> = new Map<string, string[]>();
//     const angularConfigMSAL = {
//         popUp: !isIE,
//         unprotectedResources: ["https://www.microsoft.com/en-us/"],
//         protectedResourceMap: protectedResourceMap.set(config.getSettings('api.IOMAPIUrl'), [config.getSettings('mslConfig.resourceUri')])
//     };
//     return (angularConfigMSAL as MsalAngularConfiguration);
// }

// @NgModule({
//     providers: [
//     ],
//     imports: [ CommonModule, MsalModule]
// })

@NgModule({
    declarations: [],
    imports: [  
      MsalModule
    ],
    providers: [
      {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory,
        deps: [AppConfigService]    
      },
      MsalService,    
      {
        provide: HTTP_INTERCEPTORS,    
        useClass: RebarInterceptor,
        multi: true
      },
      // {
      //   provide: MSAL_INTERCEPTOR_CONFIG,
      //   useFactory: MSALInterceptorConfigFactory,
      //   deps: [AppConfigService] 
      // },    
      // MsalGuard,
      MsalBroadcastService
    ]
  })

export class MsalApplicationModule {

    // static forRoot(): ModuleWithProviders<MsalApplicationModule>{
    //     return {
    //         ngModule: MsalApplicationModule,
    //         providers: [
    //             AppConfigService,
    //             //{ provide: AUTH_CONFIG_URL_TOKEN, useValue: configFile },
    //             {
    //                 provide: APP_INITIALIZER,
    //                 //useFactory: (config: AppConfigService) => () => config.load(),
    //                 useFactory: initializerFactory,
    //                 deps: [AppConfigService], multi: true
    //             },
    //             {
    //                 provide: MSAL_INSTANCE,
    //                 useFactory: MSALInstanceFactory
    //               },
    //               MsalService,
    //               {
    //                 provide: MSAL_INTERCEPTOR_CONFIG,
    //                 useFactory: MSALInterceptorConfigFactory
    //               },    
    //               MsalGuard,
    //             // {
    //             //     provide: MSAL_CONFIG,
    //             //     useFactory: msalConfigFactory,
    //             //     deps: [AppConfigService]
    //             // },
    //             // {
    //             //     provide: MSAL_CONFIG_ANGULAR,
    //             //     useFactory: msalAngularConfigFactory,
    //             //     deps: [AppConfigService]
    //             // },
    //             // MsalService,
    //             {
    //                 provide: HTTP_INTERCEPTORS,
    //                 useClass: RebarInterceptor, 
    //                 multi: true
    //             }
    //         ]
    //     };
    // }
}
// export function loggerCallback(logLevel, message, piiEnabled) {
//     console.log(message);
// }